import { createSelector } from "reselect";

import Legend from "@app/enum/map/Legend";
import { MapLayer } from "@app/store/mapLayers/reducers";
import { RootState } from "@app/store/rootReducer";
import LegendState from "@app/types/map/LegendState";

const layersState = (state: RootState) => state.mapLayers;

export const getLayersVisibility = createSelector(layersState, (layers) => {
  return Object.fromEntries(
    Object.entries(layers).map(([layerName, layer]) => [layerName, layer.visible])
  ) as Record<MapLayer, boolean>;
});

export const getLayerLegendsState = createSelector(
  layersState,
  (layers) =>
    Object.fromEntries(
      Object.entries(layers).map(([layerName, layer]) => [
        layerName,
        { expanded: layer.legendExpanded ?? true, isLayer: true, visible: layer.visible },
      ])
    ) as Record<Legend, LegendState>
);

export const getAlertsData = createSelector(layersState, (layers) => layers.alerts);
export const getHeatMapLayerData = createSelector(layersState, (layers) => layers.heatMap);
export const getTrafficLayerData = createSelector(layersState, (layers) => layers.traffic);
export const getBoundariesLayerData = createSelector(layersState, (layers) => layers.boundaries);
export const getUserLocationsData = createSelector(layersState, (layers) => layers.userLocations);

export * from "./alerts/selectors";
export * from "./userLocations/playback/selectors";
export * from "./userLocations/selectors";
